import React, { useEffect, useState } from 'react'
import { AuthStepsHeading, AuthStepsParagraph, ButtonWithIcon, InputBoxWraper } from '../../../constents/components';
import { PROFILE_IMAGE_WHILE_SIGNUP_LABEL_ID } from '../../../constents/htmlids'
import arrowIcon from '../../../Assets/arrow_back.svg';
import useProfileUpdater from '../../../Hooks/Registration/useProfileUpdater';
import { MAX_PROFILE_IMAGE_SIZE } from '../../../constents/numbers';
import uploadIcon from '../../../Assets/svgs/uploadIcon.svg'

const Profile = ({ details, sendToNextStep, updateFunctions }) => {
    const { updateProfileImage } = updateFunctions;
    const requirementSummary = 'Setting up the profile for you..';

    const placeholder = 'Upload Profile Pic';;
    const [loading, error, url, profileChange] = useProfileUpdater();
    const [file, setFile] = useState({});
    const [localError, setLocalError] = useState('');


    const onNextButtonClick = async () => {
        const res = await profileChange(file);
        sendToNextStep();
    }
    useEffect(() => {
        setLocalError('');
        if (file?.size) {
            if (file.size >= MAX_PROFILE_IMAGE_SIZE) {
                setLocalError(`File size should be under ${MAX_PROFILE_IMAGE_SIZE / 1024}KB`);
            }
            else {
                updateProfileImage(URL.createObjectURL(file));
            }
        }
    }, [file]);

    return (
        <div className=' flex flex-col gap-4 w-full items-center'>
            <div className=' w-full mt-4'>
                <p className=' hidden lg:block font-semibold'>{requirementSummary}</p>
            </div>


            {!loading && (<>
                <label
                    className='mt-4 cursor-pointer w-full flex gap-2 justify-center bg-black rounded-full text-white p-4'
                    htmlFor={PROFILE_IMAGE_WHILE_SIGNUP_LABEL_ID}>
                    <img src={uploadIcon} alt="uploadIcon" />
                    {placeholder}
                </label>
                <input
                    className=' hidden'
                    id={PROFILE_IMAGE_WHILE_SIGNUP_LABEL_ID}
                    type="file"
                    onChange={(e) => { setFile(e.target.files[0]) }}
                    accept="image/png, image/jpeg, image/jpg, image/heic"
                />
            </>)}
            {loading && <p className=''>uploading...</p>}
            {localError && (<p className=' text-red-500'>{localError}</p>)}
            {/* {
                details.profile ? (
                    <img
                        src={details.profile}
                        className=''
                        alt="profile-preview"
                    />
                )
                    :
                    (
                        <div className=' flex items-center  justify-center w-72 h-72 bg-gray-200 rounded-md'>
                            <p>Profile Pic Preview</p>
                        </div>
                    )
            } */}

            <ButtonWithIcon inversed={true} onButtonClick={onNextButtonClick} text={"Continue"} classNames={'p-4 w-full'} iconClassnames={"rotate-180 h-4"} />
            <p className=' text-text-color-strong font-semibold cursor-pointer' onClick={sendToNextStep}>Skip</p>
        </div>

    )
}

export default Profile;